export var config = {
    baseUrl: "https://xaviers.etranscript.in/",
    serverUrl : "https://xaviers.etranscript.in/api/",
    socketioUrl : "http://192.168.90.207:5005",
    ENV_sendgrid_Twilio : "production",
    transUploadUrl:"https://xaviers.etranscript.in/api/attestation/upload_document",
    markListUploadUrl_ : "https://xaviers.etranscript.in/api/attestation/uploadMarkList",
    markListUploadUrl : "https://xaviers.etranscript.in/api/attestation/uploadUserMarkList",
    docUploadUrl :  "https://xaviers.etranscript.in/api/etranscript/upload_doc",
    curriculumUploadUrl: "http://localhost:3535/api/attestation/upload_curriculum",
    siteKey : "6Lc3ptodAAAAAFJYTrnNN_ynEcUa2vjSOfbNmk9R"
  }
